import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';

export default function usePoliceReportSFTPConfigHook(type = 'PV') {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    ftpHost: null,
    ftpUser: null,
    ftpPass: null,
    fileFormat: null,
    filePrefix: null,
    fileSufix: null,
    ftpDirPath: null,
    sesUser: null,
    sesPass: null,
    suscription: null,
    sendSuscriptionRequestEnabled: true,
    ftpFiles: 0,
    ftpErrors: 0,
    ftpResult: [],
    testFile: null,
    isValidation: false,
    isFileList: false,
    dateSelected: null,
    ftpfileValidationError: null,
    sendStatusType: null,
  });

  useEffect(() => {
    const fetchConfig = async () => {
      await actions.loadPoliceReportConfig();
    };
    fetchConfig();
  }, [appState.selectedHotel]);

  const actions = {
    loadPoliceReportConfig: async () => {
      try {
        updateState({ isLoading: true });
        const res =
          type === 'PV'
            ? await API.getPoliceConfig({ hotelId: getSelectedHotel()?.key })
            : await API.getBookingReportConfig({ hotelId: getSelectedHotel()?.key });

        const possibleFormats = ['YYYY-MM-DD', 'YYYYMMDD', 'DD-MM-YYYY', 'DDMMYYYY'];
        const file = res?.fileFormat || '';
        const extension = file ? file.substring(file.lastIndexOf('.')) : '';
        const fileWithoutExtension = file ? file.substring(0, file.lastIndexOf(extension)) : '';

        let detectedFormat = possibleFormats.find(fmt => fileWithoutExtension.includes(fmt));
        if (!detectedFormat) detectedFormat = 'YYYY-MM-DD';

        const filePrefix = file.substring(0, file.indexOf(detectedFormat));
        const fileSufix = fileWithoutExtension.substring(
          fileWithoutExtension.indexOf(detectedFormat) + detectedFormat.length,
          fileWithoutExtension.length
        );

        updateState({
          isLoading: false,
          ftpHost: res?.ftpHost,
          ftpUser: res?.ftpUser,
          ftpPass: res?.ftpPass,
          ftpPort: res?.ftpPort,
          fileFormat: detectedFormat,
          filePrefix,
          fileSufix,
          sesUser: res?.sesUser,
          sesPass: res?.sesPass,
          ftpDirPath: res?.ftpDirPath,
          extension,
          lessorCode: res?.lessorCode,
          establishmentCode: res?.establishmentCode,
          suscription: res?.suscription === 'active',
          dateSelected: res?.dateSelected,
          sendStatusType: res?.sendStatusType || null,
        });
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },

    onCheckConnection: async () => {
      try {
        updateState({ isLoading: true });
        const res = await API.policeReportCheckSFTPConnection({
          hotelId: getSelectedHotel()?.key,
          host: state.ftpHost,
          username: state.ftpUser,
          password: state.ftpPass,
          port: parseInt(state.ftpPort),
          folder: state.ftpDirPath,
        });

        updateState({
          isLoading: false,
          ftpFiles: res && res.length > 0 ? res : [],
          isValidation: false,
          isFileList: true,
        });

        notification.success({
          message: translate('policeReport.checkConnectionSuccess'),
        });
      } catch (err) {
        console.warn(err);
        updateState({
          isLoading: false,
          ftpFiles: [],
          ftpResult: [],
          isValidation: false,
          isFileList: true,
        });
        notification.error({
          message: translate('policeReport.checkConnectionError'),
        });
      }
    },

    onSaveFTPConfig: async () => {
      try {
        updateState({ isLoading: true });

        // Fix format
        const possibleFormats = ['YYYY-MM-DD', 'YYYYMMDD', 'DD-MM-YYYY', 'DDMMYYYY'];
        if (!possibleFormats.includes(state.fileFormat)) {
          actions.setField('fileFormat', 'YYYY-MM-DD');
        }

        await API.updatePoliceSFTP({
          type: type,
          hotelId: getSelectedHotel()?.key,
          bookingProvider: constants.BOOKING_PROVIDER.SFTP,
          ftpConfig: {
            host: state.ftpHost,
            user: state.ftpUser,
            password: state.ftpPass,
            port: state.ftpPort,
            dateSelected: state.dateSelected,
            sendStatusType: state.sendStatusType || null,
          },
          fileFormat: state.extension
            ? state.fileFormat + state.extension
            : state.fileFormat + '.txt',
          filePrefix: state.filePrefix,
          fileSufix: state.fileSufix,
          ftpDirPath: state.ftpDirPath,
        });

        notification.success({
          message: translate('policeReport.saveConfigSuccess'),
        });

        // Call check connection action
        await actions.onCheckConnection();
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
        notification.error({
          message: translate('policeReport.ftpError'),
        });
      }
    },

    validateFileExport: async () => {
      try {
        updateState({ isLoading: true, ftpfileValidationError: null });

        const res = await API.policeReportValidateFileExport({
          hotelId: getSelectedHotel()?.key,
          host: state.ftpHost,
          username: state.ftpUser,
          password: state.ftpPass,
          port: parseInt(state.ftpPort),
          folder: state.ftpDirPath,
          platform: 'SES',
          file: state.testFile,
        });

        const fileContent = res.fileContent || '';
        const errors = res.errors || [];

        if (errors.length > 0) {
          const errorItems = errors.filter(item => item.error === 'error');
          const otherItems = errors.filter(item => item.error !== 'error');
          const sortedValidations = [...errorItems, ...otherItems];

          updateState({
            isLoading: false,
            ftpErrors: sortedValidations,
            ftpResult: errors && errors.length > 0 ? errors : [],
            isValidation: true,
            isFileList: false,
            fileContent,
          });
        } else {
          updateState({
            isLoading: false,
            ftpErrors: [],
            ftpResult: [],
            isValidation: true,
            isFileList: false,
            fileContent,
          });
        }

        notification.success({
          message: translate('policeReport.validateFileExportSuccess'),
        });
      } catch (err) {
        const errorMessage = err?.response?.data?.message;
        console.warn(err);

        updateState({
          isLoading: false,
          ftpErrors: [],
          ftpFiles: [],
          ftpResult: [],
          isValidation: false,
          isFileList: false,
          ftpfileValidationError: errorMessage,
        });

        notification.error({
          message: translate('policeReport.validateFileExportError'),
        });
      }
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },

    isAdmin: () => {
      return !!appState?.superUser;
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
